export default "__VITE_ASSET__Cb9Xq$C1__"